(() => {
  const root = document.querySelector('.sh-case');
  if (!root || root.dataset.searchReady) return;
  const form = root.querySelector('.sh-search');
  const input = form.querySelector('input');
  const scope = form.querySelector('select');
  const output = form.querySelector('output');
  const list = form.querySelector('ol');
  const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
  const museum = root.querySelector('#museum-shivers');
  if (museum) { museum.dataset.shSearch = 'Museum objects'; museum.dataset.shTitle = museum.querySelector('h2').textContent; museum.setAttribute('tabindex', '-1'); }
  const entries = [...root.querySelectorAll('[data-sh-search]')].map(node => ({
    node, category: node.dataset.shSearch,
    title: node.dataset.shTitle || node.id,
    text: node.textContent.replace(/\s+/g, ' ').trim(),
    haystack: normalize(node.id + ' ' + node.dataset.shSearch + ' ' + (node.dataset.shTitle || '') + ' ' + (node.dataset.shKeywords || '') + ' ' + node.textContent)
  }));
  function update() {
    const terms = normalize(input.value.trim()).split(/\s+/).filter(Boolean);
    const active = terms.length > 0 || scope.value !== '';
    const matches = entries.filter(e => (!scope.value || e.category === scope.value) && terms.every(t => e.haystack.includes(t)));
    list.replaceChildren();
    list.hidden = !active || !matches.length;
    output.textContent = !active ? `${entries.length} searchable entries across all layers.` :
      matches.length ? `${matches.length} matching ${matches.length === 1 ? 'entry' : 'entries'}.` : 'No matching entries. Try a different word or choose All layers.';
    if (!active) return;
    for (const entry of matches) {
      const li = document.createElement('li');
      const label = document.createElement('span');
      label.className = 'sh-result-category';
      label.textContent = entry.category;
      const a = document.createElement('a');
      a.href = '#' + entry.node.id;
      a.textContent = entry.title;
      const p = document.createElement('p');
      const index = terms.length ? normalize(entry.text).indexOf(terms[0]) : 0;
      const start = Math.max(0, index - 65);
      p.textContent = (start ? '…' : '') + entry.text.slice(start, start + 220) + (entry.text.length > start + 220 ? '…' : '');
      li.append(label, a, p); list.append(li);
    }
  }
  function reveal(hash) {
    let target;
    try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch { return; }
    if (!target || !root.contains(target)) return;
    for (let e = target; e && e !== root; e = e.parentElement) if (e.tagName === 'DETAILS') e.open = true;
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    requestAnimationFrame(() => {
      target.scrollIntoView({block: 'start', inline: 'nearest'});
      if (target === form) input.focus({preventScroll: true});
      else target.focus({preventScroll: true});
    });
  }
  input.addEventListener('input', update);
  scope.addEventListener('change', update);
  form.addEventListener('submit', event => { event.preventDefault(); update(); });
  form.addEventListener('reset', event => { event.preventDefault(); input.value = ''; scope.value = ''; update(); input.focus(); });
  root.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#"]');
    if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && document.getElementById(link.hash.slice(1))) {
      event.preventDefault();
      if (location.hash !== link.hash) history.pushState(null, '', location.pathname + location.search + link.hash);
      reveal(link.hash);
    }
  });
  window.addEventListener('hashchange', () => reveal(location.hash));
  const wraps = [...root.querySelectorAll('[data-sh-table]')];
  const cues = () => wraps.forEach(wrap => {
    const cue = document.getElementById(wrap.getAttribute('aria-describedby'));
    if (cue) cue.hidden = wrap.scrollWidth <= wrap.clientWidth + 1;
  });
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(cues);
    wraps.forEach(wrap => observer.observe(wrap));
  } else window.addEventListener('resize', cues);
  form.hidden = false;
  root.querySelectorAll('[data-sh-search-link]').forEach(link => link.hidden = false);
  update(); cues(); reveal(location.hash);
  root.dataset.searchReady = 'true';
})();
